import {GetterTree} from "vuex";
import {RootState} from "@/store/types";
import {EventAttributesState} from "@/store/cdp/event_attributes/types";

export const getters: GetterTree<EventAttributesState, RootState> = {
    eventAttributes: state => Array.isArray(state.eventAttributes) ? state.eventAttributes : [],
    eventAttributeItem:state => state.eventAttributeItem,
}
